/***********
 * CONFIG
 **********/

export function appconfig() {
    var baseUrl = localStorage['graphql_base_url'];
    var savedUserName = localStorage['login_user_name'];
    var pos24ApiBaseUrl = localStorage['pos24_api_base_url'];

    var hasBaseUrl = baseUrl && baseUrl.trim() !== '';
    var hasApiUrl = pos24ApiBaseUrl && pos24ApiBaseUrl.trim() !== '';

    pos24ApiBaseUrl = hasApiUrl
        ? pos24ApiBaseUrl.trim().replace(/\/+$/, '')
        : '';

    if (!hasBaseUrl) {
        return {
            isConfigured: false
        };
    }

    baseUrl = baseUrl.trim().replace(/\/+$/, '');

    var terminalName = localStorage['config_terminal_name'] || 'Sunucu';
    var departmentName = localStorage['config_department_name'] || 'Restoran';
    var ticketTypeName = localStorage['config_ticket_type_name'] || 'Restoran';
    var menuName = localStorage['config_menu_name'] || 'Menuler';
    var entityScreenName = localStorage['config_entity_screen_name'] || 'Tüm Masalar';
    var clientEntityName = localStorage['config_client_entity_name'] || 'Müşteriler';

    var GQLserv = baseUrl;
    var GQLurl = GQLserv + '/api/graphql/';
    var SIGNALRserv = GQLserv;
    var SIGNALRurl = SIGNALRserv + '/signalr';
    var SIGNALRhub = SIGNALRserv + '/signalr/hubs/';

    return {
        isConfigured: true,
        baseUrl: baseUrl,
        GQLserv: GQLserv,
        GQLurl: GQLurl,
        SIGNALRserv: SIGNALRserv,
        SIGNALRurl: SIGNALRurl,
        SIGNALRhub: SIGNALRhub,
        pos24ApiBaseUrl: pos24ApiBaseUrl,
        
        clientEntityName: clientEntityName,
        terminalName: terminalName,
        userName: savedUserName && savedUserName.trim() !== '' ? savedUserName.trim() : 'pda',
        departmentName: departmentName,
        ticketTypeName: ticketTypeName,
        menuName: menuName,
        entityScreenName: entityScreenName
    };
}



// WEBPACK FOOTER //
// ./app/config.js